(function () {
	'use strict';

	angular.module('ShargoApp')
		.controller('PressController', function($scope, $rootScope, $window, $timeout, $translate, Configuration, deviceDetector, toolsService){
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: -1000,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: true,
					dashboard: true,
					callToAction: {
						link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
						text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
						target: '',
						hide: false,
						disabled: false
					},
					profile: true
				}
			};

			$scope.news = [];
			for (var i = 1; i <= 3; ++i) {
				$scope.news.push({
					"image": Configuration.siteDomain + "/img/press-release-" + i + ".png",
					"title": "press.news.new" + i + ".title",
					"date": "press.news.new" + i + ".date",
					"text": "press.news.new" + i + ".text",
					"url": "press.news.new" + i + ".url"
				});
			}
			$scope.links = [];
			for (var i = 1; i <= 8; ++i){
				$scope.links.push({"text": "press.links.link" + i + ".text", "url": "press.links.link" + i + ".url"});
			}
			$scope.sections = [];
			for (var i = 1; i <= 3; ++i) {
				var item = {
					"title": "press.sections.section" + i + ".title",
					"texts": [],
					"hide": true
				};
				var n = 1;
				if (i == 1) {
					n = 4;
				}
				else if (i == 2) {
					n = 3;
				}
				for (var j = 1; j <= n; ++j){
					item.texts.push("press.sections.section" + i + ".text" + j);
				}
				console.log("FINAL TESTING HERE PRESS", item);
				$scope.sections.push(item);
			}

			angular.element(document).ready(function () {
				$timeout(function () {
					angular.element('.press-container .news-section .section-content').flickity({
						adaptiveHeight: false,
						pageDots: false,
						wrapAround: true
					});

					angular.element('.press-container .news-section .section-content').flickity('resize');
				});
			});
		});
})();